<script lang="ts">
  import Picture from "$lib/Picture.svelte";
  import type { ProductCategoryArticle } from "$lib/types/products";
  import { breakpoints as br } from "$lib/utils/getBreakpoints";
  import { contentBlockComponents } from "$lib/portableText/utils";
  import { PortableText } from "@portabletext/svelte";
  import Summary from "$lib/Summary.svelte";

  interface Props {
    categoryArticles: ProductCategoryArticle[];
  }

  let { categoryArticles }: Props = $props();
</script>

{#each categoryArticles as categoryArticle (categoryArticle)}
  <div class="mx-edge-x responsive-grid py-8">
    {#if categoryArticle.image?.src}
      <div class="image-circle mb-8 laptop:mb-16 text-center laptop:text-start">
        <Picture
          src={categoryArticle.image.src}
          alt={categoryArticle.image.alt}
          srcset={categoryArticle.image.srcset}
          srcsetWebp={categoryArticle.image.srcsetWebp}
          sizes={`(min-width: ${br.desktop}) 40vw, (min-width: ${br.landscape}) 65vw, 90vw`}
          width={categoryArticle.image.asset?.metadata?.dimensions?.width}
          height={categoryArticle.image.asset?.metadata?.dimensions?.height}
          circle
        />
      </div>
    {/if}

    <div class="max-w-prose mx-auto laptop:mx-0" class:laptop:mt-16={categoryArticle?.image?.src}>
      <h2 class="font-title">{categoryArticle.title}</h2>
      <p class:mb-1={categoryArticle?.content}>
        {categoryArticle.lead}
      </p>

      {#if categoryArticle?.content}
        <details class="mt-0">
          <Summary class="button-link px-0 translate-x--1">Les mer</Summary>
          <PortableText
            value={categoryArticle.content}
            components={contentBlockComponents}
            onMissingComponent={false}
          />
        </details>
      {/if}
    </div>
  </div>
{/each}

<style lang="postcss">
  @media (--laptop) {
    .responsive-grid {
      display: flex;
      gap: 4rem;
      padding-inline: 4rem;
    }
    .responsive-grid:nth-child(even) {
      flex-direction: row-reverse;
    }
  }

  .image-circle :global(img) {
    max-width: min(75svw, calc(20 * var(--text-body)));
    max-height: min(50svh, calc(20 * var(--text-body)));
  }
</style>
